module.exports = __webpack_public_path__ + "static/media/success.03bce88c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/generic/layout/Message/success.svg
// module id = 971
// module chunks = 0